import React from "react";
import { Text } from "react-internationalization";
import { FieldLabel } from "../translations/dynamic";
import { DataValidation, VERDA_CONSTS } from "../../Utils/StaticData/Constant";
const Step1Qsns = (props) => {
  const { data } = props;
  return (
    <>
      {props.productName !== "Medicare Supplement" ? (
        <div class="form-group">
          <fieldset
            class="radio radio-tab mt-3"
            id="c_qns1"
            name="c_qns1"
            onChange={props.handleChange}
            value={data.c_qns1}
          >
            <legend>{FieldLabel("drugCoverage", props.customerId)} </legend>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                name="isDrugCoverage"
                id="c_q2_yes"
                class="custom-control-input"
                value="Y"
                checked={data.isDrugCoverage === "Y"}
                onChange={props.handleChange}
              />
              <label for="c_q2_yes" class="radio-inline custom-control-label">
                <Text id="app.Yes" />
              </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                name="isDrugCoverage"
                id="c_q2_no"
                class="custom-control-input"
                value="N"
                checked={data.isDrugCoverage === "N"}
                onChange={props.handleChange}
              />
              <label for="c_q2_no" class="radio-inline custom-control-label">
                <Text id="app.No" />
              </label>
            </div>
          </fieldset>
          {data.isDrugCoverage === "Y" ? (
            <div class="row mt-3 mb-2">
              <div class="col-md-4">
                <label for="nameOfCoverage" class="control-label">
                  <Text id="app.coverage" /> * :
                </label>
                <input
                  type="text"
                  class={
                    data.nameOfCoverage === "" ? "error-input" : "form-control"
                  }
                  id="nameOfCoverage"
                  name="nameOfCoverage"
                  value={data.nameOfCoverage}
                  onChange={(event) => {
                    if (
                      event.target.value !== "" &&
                      !DataValidation.test(event.target.value)
                    ) {
                      return;
                    }
                    props.handleChange(event);
                  }}
                  maxLength="30"
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-4">
                <label for="covMemberNumber" class="control-label">
                  <Text id="app.mebernumber" />
                  *:
                </label>
                <input
                  type="text"
                  class={
                    data.covMemberNumber === "" ? "error-input" : "form-control"
                  }
                  id="covMemberNumber"
                  name="covMemberNumber"
                  value={data.covMemberNumber}
                  onChange={props.handleChange}
                  maxLength="20"
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-4">
                <label for="covGroupNumber" class="control-label">
                  <Text id="app.groupNo" /> * :
                </label>
                <input
                  type="text"
                  class={
                    data.covGroupNumber === "" ? "error-input" : "form-control"
                  }
                  id="covGroupNumber"
                  name="covGroupNumber"
                  maxLength="30"
                  value={data.covGroupNumber}
                  onChange={props.handleChange}
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
            </div>
          ) : null}
          <div class="form-group w-100">
            <fieldset class="radio radio-tab mt-3" id="authorizedrep_radio">
              <legend>
                <Text id="app.authorizedrepresentative" />{" "}
              </legend>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  name="isAuthRepresentative"
                  id="authorizedRepresentative_Y"
                  class="custom-control-input"
                  value="Y"
                  onChange={props.handleChange}
                  checked={data.isAuthRepresentative === "Y" ? true : false}
                />
                <label
                  for="authorizedRepresentative_Y"
                  class="radio-inline custom-control-label"
                >
                  <Text id="app.Yes" />
                </label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  name="isAuthRepresentative"
                  id="authorizedRepresentative_no"
                  class="custom-control-input"
                  value="N"
                  onChange={props.handleChange}
                  checked={data.isAuthRepresentative === "N" ? true : false}
                />
                <label
                  for="authorizedRepresentative_no"
                  class="radio-inline custom-control-label"
                >
                  No
                </label>
              </div>
            </fieldset>
            {data.isAuthRepresentative === "Y" ? (
              <React.Fragment>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <label class="control-label" for="nameOfRep">
                      <Text id="app.FirstName" />
                    </label>
                    <input
                      type="text"
                      class={
                        data.nameOfRep === "" ? "error-input" : "form-control"
                      }
                      name="nameOfRep"
                      id="nameOfRep"
                      required=""
                      value={data.nameOfRep}
                      maxLength="20"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="lastNameOfRep">
                      <Text id="app.LastName" />
                    </label>
                    <input
                      type="text"
                      name="lastNameOfRep"
                      id="lastNameOfRep"
                      maxLength="20"
                      required=""
                      value={data.lastNameOfRep}
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                      className={
                        data.lastNameOfRep === ""
                          ? "error-input"
                          : "form-control"
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="middleNameOfRep">
                      <Text id="app.MI" />
                    </label>
                    <input
                      type="text"
                      class={"form-control"}
                      name="middleNameOfRep"
                      id="middleNameOfRep"
                      required=""
                      maxLength="1"
                      value={data.middleNameOfRep}
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <label class="control-label" for="authorizedRepAddr">
                      <Text id="app.address1" />*
                    </label>
                    <input
                      type="text"
                      class={
                        !data.addressOfRep || data.addressOfRep === ""
                          ? "error-input"
                          : "form-control"
                      }
                      id="authorizedRepAddr"
                      name="addressOfRep"
                      value={data.addressOfRep}
                      onChange={props.handleChange}
                      required=""
                      maxLength="50"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="authorizedRepAddr2">
                      <Text id="app.address2" />
                    </label>
                    <input
                      type="text"
                      class={"form-control"}
                      id="authorizedRepAddr2"
                      name="addressOfRep2"
                      value={data.addressOfRep2}
                      onChange={props.handleChange}
                      required=""
                      maxLength="50"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="authorizedRepAddr3">
                      <Text id="app.address3" />
                    </label>
                    <input
                      type="text"
                      class={"form-control"}
                      id="authorizedRepAddr3"
                      name="address3"
                      value={data.address3}
                      onChange={props.handleChange}
                      required=""
                      maxLength="50"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <label class="control-label" for="authorizedRepCity">
                      <Text id="app.City" />*
                    </label>
                    <input
                      type="text"
                      className={
                        !data.authRepCity || data.authRepCity === ""
                          ? "error-input"
                          : "form-control"
                      }
                      id="authorizedRepCity"
                      name="authRepCity"
                      value={data.authRepCity}
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                      required=""
                      maxLength="20"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="authorizedRepState">
                      <Text id="app.State" />*
                    </label>

                    <select
                      name="authRepState"
                      id="authRepState"
                      class={
                        !data.authRepState || data.authRepState === ""
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.authRepState}
                      onChange={props.handleChange}
                    >
                      {props.statesList.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.value}
                            key={i}
                          >
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="control-label" for="authorizedRepZip">
                      <Text id="app.Zip" />*
                    </label>
                    <input
                      type="text"
                      className={
                        data.authRepZip === "" || data.authRepZip?.length !== 5
                          ? "error-input"
                          : "form-control"
                      }
                      id="authorizedRepZip"
                      name="authRepZip"
                      value={data.authRepZip}
                      onChange={props.handleChange}
                      maxLength="5"
                      required=""
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="authZip4" class="control-label">
                      <Text id="app.ZIPCode4" />
                    </label>
                    <input
                      type="text"
                      class={"form-control"}
                      name="authZip4"
                      id="authZip4"
                      value={data.authZip4}
                      onChange={props.handleChange}
                      onBlur={props.OnBlurauthZip4}
                      maxLength="4"
                      minLength="4"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <label class="control-label" for="phoneNumberOfRep">
                      <Text id="app.phno" />*
                    </label>
                    <input
                      type="text"
                      id="phoneNumberOfRep"
                      value={data.phoneNumberOfRep}
                      onChange={props.handleChange}
                      name="phoneNumberOfRep"
                      class={
                        data?.phoneNumberOfRep === "" ||
                        data?.phoneNumberOfRep?.length < 10
                          ? "error-input"
                          : "form-control"
                      }
                      placeholder="(   )   -"
                      required=""
                      maxLength="14"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="relationOfRep">
                      <Text id="app.Enrollee" />*
                    </label>
                    <select
                      name="relationOfRep"
                      id="relationOfRep"
                      class={
                        data.relationOfRep === ""
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.relationOfRep}
                      onChange={props.handleChange}
                    >
                      {props.authorizedrelations.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.value}
                            key={i}
                          >
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {/* <div class="mt-3">
                            <strong>
                              <Text id="app.authorized" />:
                            </strong>
                          </div> */}
              </React.Fragment>
            ) : null}
            {props.agentLogin === false &&
            props.customerId !== VERDA_CONSTS.ID ? (
              <React.Fragment>
                <fieldset
                  class="radio radio-tab mt-3"
                  id="licensed_sales_representative_radio"
                >
                  <legend>
                    <Text id="app.License" />
                  </legend>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      name="isLicensedSalesRep"
                      id="licensedSalesRepresentative_Y"
                      class="custom-control-input"
                      value="Y"
                      onChange={props.handleChange}
                      checked={data.isLicensedSalesRep === "Y" ? true : false}
                    />
                    <label
                      for="licensedSalesRepresentative_Y"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="app.Yes" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      name="isLicensedSalesRep"
                      id="licensedSalesRepresentative_no"
                      class="custom-control-input"
                      value="N"
                      onChange={props.handleChange}
                      checked={data.isLicensedSalesRep === "N" ? true : false}
                    />
                    <label
                      for="licensedSalesRepresentative_no"
                      class="radio-inline custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </fieldset>
              </React.Fragment>
            ) : null}
           {data.isLicensedSalesRep === "Y" && !props.isAgentLogin ? (
              <React.Fragment>
                <div class="row">
                  <div class="col-md-6">
                    <label class="control-label" for="salesRepresentativeName">
                     <Text id="app.sale" /> *
                    </label>
                    <select
                      name="salRepName"
                      id="salesRepresentativeName"
                      class={`${data.salRepName?"form-control":"error-input"}`}
                      value={data.salRepName}
                      onChange={props.handleChange}
                    >
                      {props.salesreplist.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.value}
                            key={i}
                          >
                            {item.value?item.value:item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {/* {props.isAgentLogin && ( */}
                    <div class="col-md-6">
                      <label
                        class="control-label"
                        for="salesRepresentativeLicenseNumber"
                      >
                       <Text id="app.Licenseno" />
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        name="salRepLicenseNumber"
                        id="salesRepresentativeLicenseNumber"
                        required=""
                        onChange={props.handleChange}
                        value={data.salRepLicenseNumber}
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </div>
                  {/* )} */}
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      ) : (
        <>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="enrollGrp" class={"control-label"}>
                Enrolling Group
              </label>
              <input
                id="enrollGrp"
                name="enrollGrp"
                value={data.enrollGrp}
                onChange={props.handleChange}
                class={"form-control"}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
            <div class="col-md-4">
              <label for="enrollProd" class={"control-label"}>
                Enrolling Product
              </label>
              <input
                id="enrollProd"
                name="enrollProd"
                value={data.enrollProd}
                onChange={props.handleChange}
                class={"form-control"}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
            <div class="col-md-4">
              <label for="PremAmt" class={"control-label"}>
                Premium Amount
              </label>
              <input
                id="PremAmt"
                name="PremAmt"
                value={data.PremAmt}
                onChange={props.handleChange}
                class={"form-control"}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
            <div class="col-md-4">
              <label for="enrollSource" class={"control-label"}>
                Enroll Source
              </label>
              <input
                id="enrollSource"
                name="enrollSource"
                value={data.enrollSource}
                onChange={props.handleChange}
                class={"form-control"}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="partAeffDate" class={"control-label"}>
                Hospital (Part A) Effective Date
              </label>
              <input
                type="text"
                id="partAeffDate"
                name="partAeffDate"
                maxLength="10"
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("partAeffDate")}
                value={data.partAeffDate}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
            <div class="col-md-4">
              <label for="partBeffDate" class={"control-label"}>
                Medical (Part B) Effective Date
              </label>
              <input
                type="text"
                id="partBeffDate"
                name="partBeffDate"
                maxLength="10"
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("partBeffDate")}
                value={data.partBeffDate}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
            <div class="col-md-4">
              <label for="partCeffDate" class={"control-label"}>
                Medical (Part D) Effective Date
              </label>
              <input
                type="text"
                id="partCeffDate"
                name="partCeffDate"
                maxLength="10"
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("partCeffDate")}
                value={data.partCeffDate}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
            </div>
          </div>
        </>
      )}
      <p class="medicare-note">
        <strong>
          <Text id="app.NOTE" />:
        </strong>{" "}
        <Text id="app.notePart" />.
      </p>
      {props.customerId === VERDA_CONSTS.ID && (
        <>
          <div className="row">
            <p className="col-lg-4 col-md-0 col-sm-0"></p>
            <p className="col-lg-4 col-md-12 col-sm-12">
              <strong>PRIVACY ACT STATEMENT</strong>
            </p>
            <p className="col-lg-4 col-md-0 col-sm-0"></p>
          </div>
          <div className="p-3 row">
            <p>
              The Centers for Medicare & Medicaid Services (CMS) collects
              information from Medicare plans to track beneficiary enrollment in
              Medicare Advantage (MA) plans, to improve care, and to pay
              Medicare benefits. Sections 1851 and 1860D-1 of the Social
              Security Act and Sections 422.50 and 422.60 of the Code of Federal
              Regulations (CFR) authorize the collection of this information.
              CMS may use, disclose, and exchange enrollment information for
              Medicare beneficiaries as specified in the System of Records
              Notice (SORN), "Medicare Advantage Prescription Drug (MARx),"
              system no. 09-70-0588. Your response to this form is voluntary.
              However, not answering it could affect enrollment in the plan.
            </p>
          </div>
        </>
      )}
    </>
  );
};
export default Step1Qsns;
